/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AvanceIncidencia as AvanceIncidencia,
  rec_Dr as Dr,
  rec_E$ as E$,
  rec_Go as Go,
  rec_H$ as H$,
  rec_JSXRuntime as JSXRuntime,
  rec_K$ as K$,
  rec_O$ as O$,
  rec_PreguntaIncidencia as PreguntaIncidencia,
  rec_React as React,
  rec_Ro as Ro,
  rec_S$ as S$,
  rec_SelectorMultiple as SelectorMultiple,
  rec_W$ as W$,
  rec_Za as Za,
  rec_b$ as b$,
  rec_ii as ii,
  rec_jr as jr,
  rec_n1 as n1,
  rec_q$ as q$,
  rec_r1 as r1,
  rec_ra as ra,
  rec_ui as ui,
  rec_w$ as w$,
  rec_z$ as z$,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function ReportarIncidencia({
  tipo: e,
  fundos: t = [],
  onCancelar: n,
  onListo: r,
}) {
  let i = Go(),
    [a, o] = (0, React.useState)({}),
    [s, c] = (0, React.useState)(() => {
      let e = K$();
      return t.some((t) => t.id === e) ? e : null;
    }),
    [l, u] = (0, React.useState)(``),
    [f, p] = (0, React.useState)(``),
    [m, h] = (0, React.useState)(``),
    [g, _] = (0, React.useState)(null),
    [v, y] = (0, React.useState)(1),
    [b, x] = (0, React.useState)(`adelante`),
    [S, C] = (0, React.useState)(null),
    [w, T] = (0, React.useState)(() => new Set()),
    [E, D] = (0, React.useState)(!1),
    [O, k] = (0, React.useState)(``),
    A = (0, React.useRef)(null),
    [j] = (0, React.useState)(() => new Date()),
    M = (0, React.useMemo)(
      () => e.campos.filter((e) => b$(e, a)),
      [e.campos, a],
    ),
    N = (0, React.useMemo)(() => S$(e.campos, a), [e.campos, a]),
    P = N.filter((e) => !e.fija),
    F = P.length === 1 ? N : N.filter((e) => e.fija),
    I = P.length === 1 ? [] : P,
    L = I.find((e) => e.nombre === S) ?? null,
    R = (0, React.useMemo)(
      () =>
        g && typeof URL.createObjectURL == `function`
          ? URL.createObjectURL(g)
          : null,
      [g],
    );
  (0, React.useEffect)(
    () => () => {
      R && URL.revokeObjectURL?.(R);
    },
    [R],
  );
  function z(e, t) {
    o((n) => ({
      ...n,
      [e.id]: t,
    }));
  }
  function ee(e, t) {
    o((n) => {
      let r = Array.isArray(n[e.id]) ? n[e.id] : [];
      return {
        ...n,
        [e.id]: r.includes(t) ? r.filter((e) => e !== t) : [...r, t],
      };
    });
  }
  function te(t) {
    (o((n) => w$(e.campos, n, t)), C(t), k(``));
    try {
      navigator.vibrate?.(15);
    } catch {}
  }
  function B(e) {
    T((t) => new Set(t).add(e.id));
  }
  function V() {
    let e = [];
    for (let t of M) {
      let n = a[t.id];
      if (n == null || n === `` || (Array.isArray(n) && n.length === 0))
        continue;
      let r = Array.isArray(n) ? n : [n];
      for (let n of r) {
        let r = t.opciones.find((e) => e.etiqueta === n);
        e.push(
          r
            ? {
                campoId: t.id,
                opcionId: r.id,
              }
            : {
                campoId: t.id,
                valor: String(n).trim(),
              },
        );
      }
    }
    return e;
  }
  async function H(t) {
    if ((t.preventDefault(), E)) return;
    if (!g) {
      k(`Falta la foto: sacale una a lo que encontraste.`);
      return;
    }
    (D(!0), k(``));
    let n = {
      tipoId: e.id,
      fundoId: s,
      lote: l.trim().toUpperCase(),
      ubicacion: f.trim(),
      observaciones: m.trim(),
      respuestas: V(),
    };
    try {
      let t = new FormData();
      (t.append(`datos`, JSON.stringify(n)), t.append(`foto`, await z$(g)));
      let i = await Za(`/incidencias`, t, {
        descripcion: `Reporte de ${e.nombre}`,
      });
      (q$(s), r(i));
    } catch (e) {
      (k(e.message || `No se pudo enviar. Buscá señal y probá de nuevo.`),
        i.error(`No se pudo enviar el reporte`),
        D(!1));
    }
  }
  let ne = O$(e.campos, a),
    re = ne.length === 0 && !E$(e.campos, a);
  function ie() {
    if ((k(``), v === 2)) {
      if (E$(e.campos, a)) {
        k(`Tocá qué tiene el problema.`);
        return;
      }
      if (ne.length) {
        k(`Falta: ${ne.join(`, `)}.`);
        return;
      }
    }
    (x(`adelante`), y((e) => Math.min(e + 1, n1.length - 1)));
  }
  function U(e) {
    if ((k(``), e === 0)) {
      n();
      return;
    }
    (x(e < v ? `atras` : `adelante`), y(e));
  }
  let ae = v === n1.length - 1,
    oe = t.find((e) => e.id === s),
    se = v === 1 ? !0 : v === 2 ? re : !!g,
    ce = r1[v];
  return (
    <form
      onSubmit={H}
      className={`mx-auto flex w-full max-w-2xl flex-col gap-4`}
      children={[
        <div
          className={`flex items-center justify-between gap-2`}
          children={[
            <div
              className={`flex min-w-0 items-center gap-2`}
              children={[
                <span
                  className={`animar-rebote flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-(--accent-bg) text-2xl`}
                  aria-hidden={`true`}
                  children={H$(e)}
                />,
                <h2
                  className={`truncate text-base font-semibold text-(--text-h) !m-0`}
                  children={e.nombre}
                />,
              ]}
            />,
            <button
              type={`button`}
              onClick={n}
              aria-label={`Salir del reporte`}
              className={`min-h-11 min-w-11 rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
              children={(0, JSXRuntime.jsx)(ra, {
                className: `h-4 w-4`,
              })}
            />,
          ]}
        />,
        <AvanceIncidencia actual={v} onIr={U} />,
        <section
          key={v}
          className={`${b === `adelante` ? `animar-desde-derecha` : `animar-desde-izquierda`} flex flex-col gap-3`}
          children={[
            <div
              className={`flex items-center gap-3`}
              children={[
                <span
                  className={`animar-rebote text-3xl`}
                  aria-hidden={`true`}
                  children={ce.emoji}
                />,
                <div
                  className={`min-w-0`}
                  children={[
                    <p
                      className={`text-base font-semibold text-(--text-h)`}
                      children={ce.titulo}
                    />,
                    <p
                      className={`text-xs text-(--text)`}
                      children={ce.ayuda}
                    />,
                  ]}
                />,
              ]}
            />,
            v === 1 && (
              <JSXRuntime.Fragment
                children={[
                  t.length === 0 ? (
                    <p
                      className={`text-xs text-(--text)`}
                      children={`Todavía no hay fundos cargados. Avisá a quien administra el sistema.`}
                    />
                  ) : t.length <= 8 ? (
                    <div
                      role={`radiogroup`}
                      aria-label={`Fundo`}
                      className={`animar-cascada grid grid-cols-2 gap-2 sm:grid-cols-4`}
                      children={t.map((e) => (
                        <button
                          key={e.id}
                          type={`button`}
                          role={`radio`}
                          aria-checked={s === e.id}
                          onClick={() => c(e.id)}
                          className={`flex min-h-14 items-center justify-center gap-1 rounded-2xl border-2 px-2 text-sm font-semibold transition duration-200 active:scale-[0.95] ${s === e.id ? `animar-pop border-(--accent) bg-(--accent) text-(--accent-fg) shadow-md` : `border-(--border) bg-(--bg) text-(--text-h) hover:border-(--accent-border)`}`}
                          children={[
                            (0, JSXRuntime.jsx)(ui, {
                              className: `h-4 w-4 shrink-0`,
                              "aria-hidden": `true`,
                            }),
                            ` `,
                            e.nombre,
                          ]}
                        />
                      ))}
                    />
                  ) : (
                    <label
                      className={`flex flex-col gap-1 text-sm text-(--text)`}
                      children={[
                        `Fundo`,
                        <SelectorMultiple
                          value={s}
                          onChange={c}
                          placeholder={`Elegí el fundo`}
                          opciones={t.map((e) => ({
                            value: e.id,
                            label: e.nombre,
                          }))}
                        />,
                      ]}
                    />
                  ),
                  <div
                    className={`grid gap-3 sm:grid-cols-[10rem_1fr]`}
                    children={[
                      <label
                        className={`flex flex-col gap-1 text-sm text-(--text)`}
                        children={[
                          `Lote`,
                          <input
                            className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                            value={l}
                            onChange={(e) => u(e.target.value)}
                            placeholder={`EA-01`}
                          />,
                        ]}
                      />,
                      <label
                        className={`flex flex-col gap-1 text-sm text-(--text)`}
                        children={[
                          `Dónde exactamente`,
                          <input
                            className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                            value={f}
                            onChange={(e) => p(e.target.value)}
                            placeholder={`Baño 3, comedor del lote…`}
                          />,
                        ]}
                      />,
                    ]}
                  />,
                  <p
                    className={`text-xs text-(--text)`}
                    children={[
                      `🕒 `,
                      j.toLocaleString(`es-PE`, {
                        day: `2-digit`,
                        month: `2-digit`,
                        hour: `2-digit`,
                        minute: `2-digit`,
                      }),
                      ` — la fecha y la hora se ponen solas.`,
                    ]}
                  />,
                ]}
              />
            ),
            v === 2 && (
              <JSXRuntime.Fragment
                children={[
                  N.length === 0 && (
                    <p
                      className={`text-sm text-(--text)`}
                      children={`No hay nada más que preguntar: seguí a la foto.`}
                    />
                  ),
                  F.map((e) => (
                    <PreguntaIncidencia
                      key={e.nombre}
                      grupo={e}
                      valores={a}
                      salteados={w}
                      onElegir={z}
                      onAlternar={ee}
                      onSaltear={B}
                    />
                  )),
                  I.length > 0 && !L && (
                    <div
                      className={`flex flex-col gap-2`}
                      children={[
                        F.length > 0 && (
                          <p
                            className={`text-sm font-medium text-(--text-h)`}
                            children={`¿Y qué tiene el problema?`}
                          />
                        ),
                        <div
                          className={`animar-cascada grid grid-cols-2 gap-3 sm:grid-cols-3`}
                          children={I.map((e) => (
                            <button
                              key={e.nombre}
                              type={`button`}
                              onClick={() => te(e.nombre)}
                              className={`transition duration-150 ease-(--curva) active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) focus-visible:ring-offset-1 focus-visible:ring-offset-(--bg) disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100 flex min-h-28 flex-col items-center justify-center gap-2 rounded-2xl border-2 border-(--border) bg-(--bg) p-3 text-center text-sm font-semibold text-(--text-h) transition duration-200 hover:-translate-y-0.5 hover:border-(--accent-border) hover:shadow-md active:scale-[0.95]`}
                              children={[
                                <span
                                  className={`animar-flotar text-4xl`}
                                  aria-hidden={`true`}
                                  children={W$(e.nombre)}
                                />,
                                e.nombre,
                              ]}
                            />
                          ))}
                        />,
                      ]}
                    />
                  ),
                  L && (
                    <div
                      className={`flex flex-col gap-3`}
                      children={[
                        <div
                          className={`animar-pop flex items-center justify-between gap-2 rounded-2xl border-2 border-(--accent) bg-(--accent-bg) px-3 py-2`}
                          children={[
                            <span
                              className={`flex items-center gap-2 text-sm font-semibold text-(--text-h)`}
                              children={[
                                <span
                                  className={`text-2xl`}
                                  aria-hidden={`true`}
                                  children={W$(L.nombre)}
                                />,
                                ` `,
                                L.nombre,
                              ]}
                            />,
                            <button
                              type={`button`}
                              onClick={() => {
                                (o((t) => w$(e.campos, t, null)), C(null));
                              }}
                              className={`min-h-11 rounded-full px-3 text-xs font-medium text-(--accent-texto) hover:bg-(--bg)`}
                              children={`Cambiar`}
                            />,
                          ]}
                        />,
                        <PreguntaIncidencia
                          grupo={L}
                          sinTitulo={!0}
                          valores={a}
                          salteados={w}
                          onElegir={z}
                          onAlternar={ee}
                          onSaltear={B}
                        />,
                      ]}
                    />
                  ),
                ]}
              />
            ),
            ae && (
              <JSXRuntime.Fragment
                children={[
                  <input
                    ref={A}
                    type={`file`}
                    accept={`image/*`}
                    capture={`environment`}
                    className={`hidden`}
                    onChange={(e) => {
                      (_(e.target.files?.[0] ?? null), k(``));
                    }}
                  />,
                  g ? (
                    <div
                      className={`animar-destello relative overflow-hidden rounded-2xl border border-(--border)`}
                      children={[
                        R ? (
                          <img
                            src={R}
                            alt={`La foto del reporte`}
                            className={`max-h-72 w-full object-cover`}
                          />
                        ) : (
                          <p
                            className={`p-4 text-sm text-(--success)`}
                            children={`Foto lista`}
                          />
                        ),
                        <span
                          className={`animar-rebote absolute bottom-2 left-2 rounded-full bg-(--bg) px-3 py-1 text-xs font-semibold text-(--text-h) shadow`}
                          children={`¡Buena foto! 📸`}
                        />,
                        <button
                          type={`button`}
                          onClick={() => {
                            (_(null), A.current && (A.current.value = ``));
                          }}
                          aria-label={`Quitar la foto`}
                          className={`absolute top-2 right-2 flex h-10 w-10 items-center justify-center rounded-full bg-(--bg) text-(--text-h) shadow`}
                          children={(0, JSXRuntime.jsx)(ra, {
                            className: `h-4 w-4`,
                          })}
                        />,
                      ]}
                    />
                  ) : (
                    <button
                      type={`button`}
                      onClick={() => A.current?.click()}
                      className={`animar-latido flex min-h-44 flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-(--accent-border) bg-(--accent-bg) text-(--accent-texto) transition active:scale-[0.98]`}
                      children={[
                        <Dr
                          className={`animar-flotar h-12 w-12`}
                          aria-hidden={`true`}
                        />,
                        <span
                          className={`text-sm font-semibold`}
                          children={`Sacar una foto`}
                        />,
                        <span
                          className={`text-xs text-(--text)`}
                          children={`Obligatoria`}
                        />,
                      ]}
                    />
                  ),
                  <label
                    className={`flex flex-col gap-1 text-sm text-(--text)`}
                    children={[
                      `Contá qué pasó (opcional)`,
                      <textarea
                        className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) min-h-20`}
                        value={m}
                        onChange={(e) => h(e.target.value)}
                        placeholder={`Desde cuándo, a quién afecta…`}
                      />,
                    ]}
                  />,
                  <details
                    className={`rounded-2xl border border-(--border) px-3 py-2 text-sm`}
                    children={[
                      <summary
                        className={`min-h-9 cursor-pointer py-1 font-medium text-(--text-h)`}
                        children={`Revisá tu reporte`}
                      />,
                      <dl
                        className={`mt-1 grid grid-cols-[6rem_1fr] gap-x-2 gap-y-1 text-(--text)`}
                        children={[
                          <dt children={`Qué`} />,
                          <dd
                            className={`text-(--text-h)`}
                            children={[e.nombre, S ? ` · ${S}` : ``]}
                          />,
                          <dt children={`Dónde`} />,
                          <dd
                            className={`text-(--text-h)`}
                            children={
                              [oe?.nombre, l.trim().toUpperCase(), f.trim()]
                                .filter(Boolean)
                                .join(` · `) || `—`
                            }
                          />,
                          M.filter(
                            (e) =>
                              a[e.id] != null && String(a[e.id]).trim() !== ``,
                          ).map((e) => (
                            <div
                              key={e.id}
                              className={`contents`}
                              children={[
                                <dt children={e.etiqueta} />,
                                <dd
                                  className={`text-(--text-h)`}
                                  children={
                                    Array.isArray(a[e.id])
                                      ? a[e.id].join(`, `)
                                      : a[e.id]
                                  }
                                />,
                              ]}
                            />
                          )),
                        ]}
                      />,
                    ]}
                  />,
                ]}
              />
            ),
          ]}
        />,
        O && (
          <p
            role={`alert`}
            className={`animar-pop text-sm text-(--error)`}
            children={O}
          />
        ),
        <div
          className={`sticky bottom-0 flex items-center justify-between gap-2 border-t border-(--border) bg-(--bg) py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]`}
          children={[
            <button
              type={`button`}
              onClick={() => U(v - 1)}
              className={`${zo} min-h-12`}
              children={[
                (0, JSXRuntime.jsx)(jr, {
                  className: `mr-1 inline h-4 w-4`,
                }),
                ` Atrás`,
              ]}
            />,
            ae ? (
              <button
                type={`submit`}
                disabled={E}
                className={`${Ro} min-h-12 flex-1 sm:flex-none ${se ? `animar-latido` : ``}`}
                children={[
                  E &&
                    (0, JSXRuntime.jsx)(ii, {
                      className: `mr-1 inline h-4 w-4 animate-spin`,
                    }),
                  `Reportar`,
                ]}
              />
            ) : (
              <button
                type={`button`}
                onClick={ie}
                className={`${Ro} min-h-12 flex-1 sm:flex-none ${se ? `animar-latido` : ``}`}
                children={`Continuar`}
              />
            ),
          ]}
        />,
      ]}
    />
  );
}
